<div id="layout" class="sign_in f_col users-page no_max_size">
  <div class="scroll_wrapper">
    <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{'menu.users' | translate}}</app-view-title>
    <app-table #smartTable *ngIf="config" class="userSmartTable"
    [config]="config"
    [initialConfig]="initialConfig"
    [dataTransformer]="tableDataTransformer"
    [serverItemCount]="totalCount"
    [topButtons]="topButtons"
    (onRowClick)="navigateTo($event.id.value)"
    (onQueryChange)="onQueryChange($event)"
    (onLoadingStateChange)="onLoadingStateChange($event)">
    </app-table>
    <div class="btns-container resp_maxSize_l mb_20">
      <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    </div>
  </div>
</div>
